// Mock data for AYMORENOV CONSTRUCTION INC
import { translations } from './translations/translations';

// Helper function to get translated services based on current language
export const getServices = (language = 'fr') => {
  const t = translations[language];
  return [
    {
      id: 1,
      title: t.services.kitchenReno.title,
      description: t.services.kitchenReno.description,
      icon: "ChefHat",
      features: t.services.kitchenReno.features,
      contactForPrice: true
    },
    {
      id: 2,
      title: t.services.bathroomReno.title,
      description: t.services.bathroomReno.description,
      icon: "Bath",
      features: t.services.bathroomReno.features,
      contactForPrice: true
    },
    {
      id: 3,
      title: t.services.exteriorReno.title,
      description: t.services.exteriorReno.description,
      icon: "Home",
      features: t.services.exteriorReno.features,
      contactForPrice: true
    },
    {
      id: 4,
      title: t.services.flooring.title,
      description: t.services.flooring.description,
      icon: "Square",
      features: t.services.flooring.features,
      contactForPrice: true
    },
    {
      id: 5,
      title: t.services.cleaning.title,
      description: t.services.cleaning.description,
      icon: "Zap",
      features: t.services.cleaning.features,
      contactForPrice: true
    },
    {
      id: 6,
      title: t.services.paving.title,
      description: t.services.paving.description,
      icon: "Palette",
      features: t.services.paving.features,
      contactForPrice: true
    }
  ];
};

export const specialists = [
  {
    id: 1,
    name: "Pierre Dubois",
    specialty: "Rénovation de cuisine",
    experience: "12 ans",
    rating: 4.9,
    completedProjects: 150,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop&crop=face",
    description: "Expert en rénovation de cuisines modernes avec une spécialisation dans les designs contemporains.",
    skills: ["Design moderne", "Électricité", "Plomberie", "Carrelage"],
    certifications: ["RBQ", "CNESST"],
    phone: "+1 (514) 123-4567",
    email: "pierre.dubois@aymorenov.com"
  },
  {
    id: 2,
    name: "Marie Tremblay",
    specialty: "Salle de bain",
    experience: "8 ans",
    rating: 4.8,
    completedProjects: 120,
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b47c?w=300&h=300&fit=crop&crop=face",
    description: "Spécialiste en rénovation de salles de bain avec expertise en accessibilité et design universel.",
    skills: ["Plomberie avancée", "Carrelage", "Accessibilité", "Design"],
    certifications: ["RBQ", "CNESST", "Plombier certifié"],
    phone: "+1 (514) 123-4568",
    email: "marie.tremblay@aymorenov.com"
  },
  {
    id: 3,
    name: "Jean-Michel Lavoie",
    specialty: "Rénovation extérieure",
    experience: "15 ans",
    rating: 4.9,
    completedProjects: 200,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&h=300&fit=crop&crop=face",
    description: "Expert en rénovation extérieure, toitures, terrasses et façades avec plus de 15 ans d'expérience.",
    skills: ["Toiture", "Revêtement", "Terrasses", "Isolation"],
    certifications: ["RBQ", "CNESST", "Couvreur certifié"],
    phone: "+1 (514) 123-4569",
    email: "jean-michel.lavoie@aymorenov.com"
  },
  {
    id: 4,
    name: "Sophie Gagnon",
    specialty: "Design d'intérieur",
    experience: "10 ans",
    rating: 4.7,
    completedProjects: 80,
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=300&h=300&fit=crop&crop=face",
    description: "Designer d'intérieur spécialisée dans les espaces résidentiels modernes et fonctionnels.",
    skills: ["Design conceptuel", "Sélection matériaux", "3D", "Coordination"],
    certifications: ["APDIQ", "Designer certifiée"],
    phone: "+1 (514) 123-4570",
    email: "sophie.gagnon@aymorenov.com"
  },
  {
    id: 5,
    name: "Marc Bouchard",
    specialty: "Électricité et domotique",
    experience: "18 ans",
    rating: 4.9,
    completedProjects: 300,
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=300&h=300&fit=crop&crop=face",
    description: "Maître électricien spécialisé dans les installations modernes et les systèmes domotiques.",
    skills: ["Électricité générale", "Domotique", "Système sécurité", "Éclairage LED"],
    certifications: ["Maître électricien", "RBQ", "CNESST"],
    phone: "+1 (514) 123-4571",
    email: "marc.bouchard@aymorenov.com"
  },
  {
    id: 6,
    name: "Caroline Roy",
    specialty: "Planchers et revêtements",
    experience: "7 ans",
    rating: 4.6,
    completedProjects: 90,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=300&h=300&fit=crop&crop=face",
    description: "Experte en installation de planchers et revêtements de tous types pour espaces résidentiels.",
    skills: ["Plancher bois", "Céramique", "Vinyle", "Tapis"],
    certifications: ["RBQ", "CNESST"],
    phone: "+1 (514) 123-4572",
    email: "caroline.roy@aymorenov.com"
  }
];

export const services = [
  {
    id: 1,
    title: "Rénovation de cuisine",
    description: "Transformation complète de votre cuisine avec design moderne et fonctionnel",
    icon: "ChefHat",
    features: ["Électricité et plomberie", "Carrelage", "Consultation des équipements"],
    contactForPrice: true
  },
  {
    id: 2,
    title: "Rénovation de salle de bain",
    description: "Création d'espaces détente modernes et accessibles",
    icon: "Bath",
    features: ["Plomberie", "Carrelage et céramique", "Éclairage LED", "Accessibilité universelle"],
    contactForPrice: true
  },
  {
    id: 3,
    title: "Rénovation extérieure",
    description: "Amélioration de l'apparence et de la performance énergétique",
    icon: "Home",
    features: ["Toiture", "Revêtement extérieur", "Isolation", "Terrasses et patios", "Clôture extérieur des jardins"],
    contactForPrice: true
  },
  {
    id: 4,
    title: "Planchers et revêtements",
    description: "Installation de planchers durables et esthétiques",
    icon: "Square",
    features: ["Bois franc", "Céramique et porcelaine", "Vinyle de luxe", "Tapis et moquette"],
    contactForPrice: true
  },
  {
    id: 5,
    title: "Nettoyage",
    description: "Nettoyage après finissions des travaux",
    icon: "Zap",
    features: ["Nettoyage après finissions des travaux"],
    contactForPrice: true
  },
  {
    id: 6,
    title: "Pavé et asphalte",
    description: "Pavé extérieur et asphalte chaud/froid",
    icon: "Palette",
    features: ["Pavé extérieur", "Asphalte chaud/froid"],
    contactForPrice: true
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Kevin Bourgois",
    location: "Nouveau-Brunswick",
    rating: 5,
    comment: "Excellent travail de Mohamed et son équipe AYMORENOV! Installation de planchers impeccable et service professionnel.",
    project: "Installation de planchers",
    date: "",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face"
  },
  {
    id: 2,
    name: "Aymen Nejm",
    location: "Nouveau-Brunswick",
    rating: 5,
    comment: "Travaux de peinture et finition exceptionnels! Mohamed est très professionnel et respecte les délais.",
    project: "Peinture et finition",
    date: "",
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b47c?w=100&h=100&fit=crop&crop=face"
  },
  {
    id: 3,
    name: "Michelle Nowlan",
    location: "Nouveau-Brunswick",
    rating: 5,
    comment: "Service de consultation formidable! Mohamed prend le temps d'expliquer et donne d'excellents conseils.",
    project: "Consultation et planification",
    date: "",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face"
  }
];

export const projectGallery = [
  {
    id: 1,
    title: "Installation de parquet - Projet Résidentiel",
    category: "Planchers",
    beforeImage: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=300&fit=crop",
    afterImage: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=400&h=300&fit=crop",
    description: "Installation professionnelle de parquet avec finition impeccable par notre équipe AYMORENOV.",
    specialist: "Équipe AYMORENOV",
    duration: "3 jours",
    budget: "Sur devis"
  },
  {
    id: 2,
    title: "Travaux de peinture et finition - Projet Montréal",
    category: "Design",
    beforeImage: "https://images.unsplash.com/photo-1584616385085-34d7d5839f04?w=400&h=300&fit=crop",
    afterImage: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=400&h=300&fit=crop",
    description: "Rénovation complète avec travaux de peinture et finition par nos spécialistes qualifiés.",
    specialist: "Mohamed Obad",
    duration: "1 semaine",
    budget: "Sur devis"
  },
  {
    id: 3,
    title: "Consultation et planification projet",
    category: "Design",
    beforeImage: "https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?w=400&h=300&fit=crop",
    afterImage: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=400&h=300&fit=crop",
    description: "Service de consultation personnalisé avec révision des plans et conseils d'experts en bureau.",
    specialist: "Mohamed Obad",
    duration: "Consultation",
    budget: "Gratuit"
  },
  {
    id: 4,
    title: "Travaux de charpenterie et toiture",
    category: "Extérieur",
    beforeImage: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=300&fit=crop",
    afterImage: "https://customer-assets.emergentagent.com/job_aymorenov-catalog/artifacts/ob34q0m7_charpentrie.jpg",
    description: "Travaux de charpenterie et toiture professionnels réalisés par nos experts AYMORENOV.",
    specialist: "Équipe AYMORENOV",
    duration: "2-3 jours",
    budget: "Sur devis"
  }
];

// Helper function to get translated company values
export const getCompanyValues = (language = 'fr') => {
  const t = translations[language];
  return [
    {
      title: t.values.quality.title,
      description: t.values.quality.description
    },
    {
      title: t.values.reliability.title,
      description: t.values.reliability.description
    },
    {
      title: t.values.innovation.title,
      description: t.values.innovation.description
    },
    {
      title: t.values.service.title,
      description: t.values.service.description
    }
  ];
};

export const companyInfo = {
  name: "AYMORENOV CONSTRUCTION INC",
  tagline: "Votre partenaire de confiance en rénovation", 
  description: "Depuis plus de 15 ans, AYMORENOV CONSTRUCTION INC transforme les rêves de rénovation en réalité. Notre équipe de spécialistes certifiés offre des services de qualité supérieure pour tous vos projets résidentiels.",
  founded: "2008",
  projectsCompleted: "1000+",
  clientsSatisfied: "800+",
  warranty: "5 ans",
  contact: {
    phone: "506-588-4919",
    email: "aymorenov25@gmail.com",
    whatsapp: "506-588-4919",
    contactPerson: "Mohamed Obad",
    address: "Nouveau-Brunswick, Canada",
    hours: "Lun-Ven: 8h-17h, Sam: 9h-15h"
  },
  certifications: ["RBQ", "CNESST", "APCHQ", "CAA-Québec"],
  values: [
    {
      title: "Qualité",
      description: "Nous utilisons uniquement des matériaux de première qualité et respectons les plus hauts standards de l'industrie."
    },
    {
      title: "Fiabilité",
      description: "Nos équipes respectent les délais convenus et maintiennent une communication transparente tout au long du projet."
    },
    {
      title: "Innovation",
      description: "Nous intégrons les dernières technologies et tendances pour créer des espaces modernes et fonctionnels."
    },
    {
      title: "Service client",
      description: "Votre satisfaction est notre priorité. Nous offrons un service personnalisé et un suivi post-projet."
    }
  ]
};

// Utility functions for frontend
export const getSpecialistsByCategory = (category) => {
  if (!category || category === "Tous") return specialists;
  return specialists.filter(specialist => 
    specialist.specialty.toLowerCase().includes(category.toLowerCase()) ||
    specialist.skills.some(skill => skill.toLowerCase().includes(category.toLowerCase()))
  );
};

export const getProjectsByCategory = (category) => {
  if (!category || category === "Tous") return projectGallery;
  return projectGallery.filter(project => project.category === category);
};

export const specialtyCategories = [
  "Tous",
  "Cuisine",
  "Salle de bain", 
  "Extérieur",
  "Design",
  "Électricité",
  "Planchers"
];

export const projectCategories = [
  "Tous",
  "Cuisine",
  "Salle de bain",
  "Extérieur", 
  "Design"
];